<script context="module">
  export { default as layout } from "./Shared/Layout.svelte";
</script>

<script>
  import { inertia } from "@inertiajs/svelte";

  export let status = 400,
    back;

  $: title =
    {
      503: "Service Unavailable",
      500: "Server Error",
      429: "Too Many Requests",
      419: "Session Expired",
      405: "Method Not Allowed",
      404: "Page Not Found",
      403: "Forbidden",
      401: "Unauthorized",
    }[status] || "An Error Occurred";

  $: description =
    {
      503: "Sorry, we are doing some maintenance. Please check back soon.",
      500: "Whoops, something went wrong on our servers.",
      429: "Sorry, you are making too many requests to our servers.",
      419: "Sorry, your session has expired. Please refresh and try again.",
      405: "Sorry, something went wrong.",
      404: "Sorry, the page you are looking for could not be found.",
      403: "Sorry, you are forbidden from accessing this page.",
      401: "Sorry, you are not authorized to access this page.",
    }[status] || "Something went wrong.";
</script>

<div class="h-100">
  <div id="notfound" class="h-100">
    <div class="notfound h-100 align-content-center">
      <div class="notfound-404">
        <h1>{status}</h1>
      </div>
      <h2>{title}</h2>
      <p>
        {description}<br />
        <a href={back || window.route("home")} use:inertia
          >{back ? "Return to previous page" : "Return to homepage"}</a
        >
      </p>
    </div>
  </div>
</div>
